export default "__VITE_ASSET__8af175cd__"